export default __webpack_public_path__ + "fb17618d535b1472d4bb99a794a9526e.svg";